<pm-widget-base-wrapper [isLoading]="isLoading" [name]="name">
  <ng-template
    pmWidgetTitle
    infoTooltipText="
      {{ 'RESULT.INSIGHTS.WIDGETS.SINGLE_FORECASTS.TOOLTIP' | translate }}
    "
  >
    {{ 'RESULT.INSIGHTS.WIDGETS.SINGLE_FORECASTS.TITLE' | translate }}
  </ng-template>

  <ng-template pmWidgetHeader>
    <pm-form-field label="RESULT.INSIGHTS.GENERAL.SELECT_FILTER">
      <pm-form-input-select
        [allowSearching]="true"
        [ngModel]="selectedFilterColumn()"
        (ngModelChange)="onFilterChange($event)"
        [disabled]="invalidDataset"
        labelKey="label"
        propertyKey="label"
        [data]="filterOptionsForSelect()"
      />
    </pm-form-field>

    <pm-form-field label="RESULT.INSIGHTS.GENERAL.SELECT_DATASET">
      <pm-form-input-select
        [multiSelect]="true"
        [clearable]="true"
        [allowUnselect]="true"
        [allowSelectAll]="true"
        [formControl]="selectedValuesFormControl"
        [selectableItemsLimit]="MAX_NUMBER_OF_SELECTIONS"
        labelKey="label"
        propertyKey="label"
        [data]="filterValuesForSelect()"
      />
    </pm-form-field>
  </ng-template>

  <ng-template pmWidgetContent>
    @if (!this.invalidDataset) {
      @if (this.isError) {
        <div class="flex justify-center items-center h-full text-center p-4">
          <pm-h3>
            {{ 'RESULT.INSIGHTS.GENERAL.TECHNICAL_ERROR' | translate }}
          </pm-h3>
        </div>
      } @else {
        <highcharts-chart
          class="w-full"
          id="single-forecasts-chart"
          [oneToOne]="true"
          [options]="chartOptions()"
        >
        </highcharts-chart>
      }
    } @else {
      <div class="flex justify-center items-center h-full text-center p-4">
        <p class="text-lg text-gray-600">
          {{
            'RESULT.INSIGHTS.WIDGETS.SINGLE_FORECASTS.DATASET_INVALID'
              | translate
          }}
        </p>
      </div>
    }
  </ng-template>

  <ng-template pmWidgetActions>
    @if (isDialogInstance) {
      <pm-button
        variant="subdued"
        [pmTooltip]="'RESULT.INSIGHTS.BUTTONS.EXIT_FULL_SCREEN_TOOLTIP'"
        (handleClick)="exitFullScreen()"
        [icon]="scanIcon"
      />
    } @else {
      <pm-button
        variant="subdued"
        [pmTooltip]="'RESULT.INSIGHTS.BUTTONS.FULL_SCREEN_TOOLTIP'"
        [icon]="scanIcon"
        (handleClick)="
          showFullScreen(SingleForecastsWidgetComponent, {
            resolution: this.resolution,
            targetUnit: this.targetUnit,
            filterColumn: this.selectedFilter().column,
            filterOptions: this.selectedValuesFormControl.getRawValue(),
          })
        "
      />
    }
  </ng-template>
</pm-widget-base-wrapper>
